import { css } from '@compiled/react';
import { defineMessage, useIntl } from 'react-intl';

import { Link } from '@/libraries/design/components/link/src/link';
import { wacToken } from '@/libraries/design/foundations';
import { useLocalizedHref } from '@/libraries/web-framework/src/localization/use-localized-href';
import { ProductKeyTypes } from '@/libraries/wpl/foundations/src/data-event-props';
import { GlobalNavDropdownLinkColumn } from '@/patterns/global-nav/src/layouts/global-nav-dropdown-link-column';

export const LoomFeaturesDropdown = () => {
	const intl = useIntl();

	const productKey: ProductKeyTypes = 'loom';

	const loomLinks = {
		features: {
			id: 'features',
			title: defineMessage({
				id: 'bitbucketnav.subnav.loomFeatures.links.features',
				defaultMessage: 'Explore Features',
			}),
			items: [
				{
					id: 'meeting-notes',
					text: defineMessage({
						id: 'loom-product-nav.loomFeatures.links.meeting-notes',
						defaultMessage: 'Meeting Notes',
					}),
					href: useLocalizedHref('/software/loom/ai-meeting'),
				},
				{
					id: 'screen-recorder',
					text: defineMessage({
						id: 'loom-product-nav.loomFeatures.links.screen-recorder',
						defaultMessage: 'Screen Recorder',
					}),
					href: useLocalizedHref('/software/loom/screen-recorder'),
				},
				{
					id: 'screenshots',
					text: defineMessage({
						id: 'loom-product-nav.loomFeatures.links.screenshots',
						defaultMessage: 'Screenshots',
					}),
					href: useLocalizedHref('/software/loom/screenshot'),
				},
				{
					id: 'loom-ai',
					text: defineMessage({
						id: 'loom-product-nav.loomFeatures.links.loom-ai',
						defaultMessage: 'Loom AI',
					}),
					href: useLocalizedHref('/software/loom/ai'),
				},
				{
					id: 'editing',
					text: defineMessage({
						id: 'loom-product-nav.loomFeatures.links.editing',
						defaultMessage: 'Editing',
					}),
					href: useLocalizedHref('/software/loom/editing'),
				},
			],
		},
	};
	const linkColumns = Object.values(loomLinks);

	return (
		<>
			{linkColumns.map((column) => {
				return (
					<GlobalNavDropdownLinkColumn key={column.id}>
						<span
							css={css({
								textTransform: 'uppercase',
								color: wacToken('color.neutral.dark0'),
								fontSize: '0.75rem',
								fontFamily: wacToken('font.charlie.text'),
								fontWeight: 700,
								lineHeight: '1rem',
							})}
						>
							{intl.formatMessage(column.title)}
						</span>
						<div
							css={css({
								display: 'grid',
								gridAutoRows: '40px',
							})}
						>
							{column.items.map((link) => {
								return (
									<div
										key={link.id}
										css={css({
											// nav doesn't follow the typography
											// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
											a: {
												fontWeight: 400,
												fontSize: '0.875rem',
												color: wacToken('color.neutral.dark0'),
												'&:visited': {
													textDecoration: 'none',
													color: wacToken('color.neutral.dark0'),
												},
											},
											display: 'flex',
											alignItems: 'end',
										})}
									>
										{/* eslint-disable-next-line @atlassian/a11y/anchor-has-content, @atlassian/a11y/link-name */}
										<Link
											type="anchor"
											href={link.href}
											text={intl.formatMessage(link.text)}
											ariaLabel={intl.formatMessage(link.text)}
											dataEventProps={{
												'data-event': 'clicked',
												'data-event-component': 'linkButton',
												'data-event-container': 'globalNavSubnav',
												'data-product-key': productKey,
											}}
										/>
									</div>
								);
							})}
						</div>
					</GlobalNavDropdownLinkColumn>
				);
			})}
		</>
	);
};
